/* eslint-disable no-shadow */

import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { ValidationError } from '@/errors';
import axios from 'axios';

const endpoint = `${apiEndpoint}/keywords-trans`;

const state = {
  projectKeys: null,
  pending: false,
  error: null,
  updatePending: false,
  updateError: null,
  totalCount: null,
  projectPage: null,
  project: null,
};

const getters = {
  loaded: (state) => !state.pending && state.projectKeys != null,
  projectKeys: (state, getters) => (getters.loaded ? state.projectKeys : []),
  noProjectKeys: (state, getters) => getters.loaded && !getters.projectKeys.length && state.totalCount === 0,
};

const mutations = {
  clearErrors(state) {
    state.error = null;
    state.updateError = null;
  },
  beforeLoading(state, initial = false) {
    if (initial) {
      state.projectKeys = null;
    }
    state.error = null;
    state.pending = true;
  },
  beforeUpdate(state) {
    state.updateError = null;
    state.updatePending = true;
  },
  error(state, error) {
    state.pending = false;
    state.error = error;
  },
  data(state, {
    projectKeys, totalCount, projectPage, project,
  }) {
    state.pending = false;
    state.projectKeys = projectKeys;
    state.totalCount = totalCount;
    state.projectPage = projectPage;
    state.project = project;
  },
  update(state, error = null) {
    state.updatePending = false;
    state.updateError = error;
  },
  created(state) {
    state.updatePending = false;
    state.updateError = null;
  },
  modified(state) {
    state.updatePending = false;
    state.updateError = null;
  },
  deleted(state, pid) {
    const idx = state.projectKeys.findIndex((projectKey) => projectKey.id === pid);
    if (idx !== -1) {
      state.projectKeys.splice(idx, 1);
    }
    state.updatePending = false;
    state.updateError = null;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 422:
      if (data.errors) {
        data.message = data.errors[Object.keys(data.errors)[0]];
      }
      err = new ValidationError(status, data.message, data.errors);
      break;
    default:
      break;
  }
  return err;
}

const actions = {
  async fetchData({ commit }, payload) {
    commit('beforeLoading');
    try {
      const result = await ApiService.get(`${endpoint}?currentPage=${payload.currentPage}&projectPageId=${payload.projectPageId}&languageId=${payload.languageId}&withoutTranslations=${payload.withoutTranslations}&q=${payload.q}`);
      const projectKeys = result.data.data.items;
      const totalCount = result.data.data.totalRows;
      const { projectPage } = result.data.data;
      const { project } = result.data.data;
      commit('data', {
        projectKeys, totalCount, projectPage, project,
      });
    } catch (error) {
      commit('error', error);
    }
  },
  async fetchAllTranslations({ commit }, payload) {
    commit('beforeLoading');
    try {
      const result = await ApiService.get(`${endpoint}/translations/all?currentPage=${payload.currentPage}&projectId=${payload.projectId}&languageId=${payload.languageId}&withoutTranslations=${payload.withoutTranslations}&q=${payload.q}&deepL=true&is_automatedTab=true&toBeChecked=false`);
      const projectKeys = result.data.data.items;
      const totalCount = result.data.data.totalRows;
      const { project } = result.data.data;
      commit('data', {
        projectKeys, totalCount, project,
      });
    } catch (error) {
      commit('error', error);
    }
  },
  async updateDeeplTranslations({ commit }) {
    commit('beforeLoading');
    try {
      await axios.get(`${apiEndpoint}/automateKeywords?currentPage=1&projectId=1&languageId=1&withoutTranslations=false&q=&deepL=true&updateAll=true`);
    } catch (error) {
      commit('error', error);
      throw handleApiError(commit, error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
